<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    width="80%"
    :visible.sync="viewData.visible">
    <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1>
    <H3 style="text-align:center">{{dataForm.projectName}}</H3>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="200px" class="org-dialog-form">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="供应商账号" prop="account">
            {{dataForm.account}}
          </el-form-item>          
        </el-col>
        <el-col :span="8">
          <el-form-item label="账号密码" prop="password">
            {{dataForm.password}}
          </el-form-item>          
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商类型" prop="supplierType">
            <el-select v-model="dataForm.supplierType" placeholder="请选择" clearable @focus="getJobs">
              <el-option
                v-for="item in supplierTypeList"
                :key="item.key"
                :label="item.name"
                :value="item.key"/>
            </el-select>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item 
            label="供应商名称" prop="supplierName">
            <el-input v-model="dataForm.supplierName" placeholder="供应商名称"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item 
            label="地址" prop="supplierAddress">
            <el-input v-model="dataForm.supplierAddress" placeholder="商品质量标准"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="电话" prop="supplierTel">
            <el-input v-model="dataForm.supplierTel" placeholder="电话"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="传真" prop="supplierFax">
            <el-input v-model="dataForm.supplierFax" placeholder="传真"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="主要供货产品" prop="supplyProduct">
            <el-input v-model="dataForm.supplyProduct" placeholder="主要供货产品"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="所供车型" prop="supplyCarStyle">
            <el-input v-model="dataForm.supplyCarStyle" placeholder="所供车型"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="法人代表" prop="legalRepresentative">
            <el-input v-model="dataForm.legalRepresentative" placeholder="法人代表"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行*" prop="bank">
            <el-input v-model="dataForm.bank" placeholder="开户银行*"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="银行帐号*" prop="bankCode">
            <el-input v-model="dataForm.bankCode" placeholder="银行帐号*"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <!-- 社会统一信用代码 -->
          <el-form-item label="税务登记号*" prop="taxCode">
            <el-input v-model="dataForm.taxCode" placeholder="税务登记号*"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <!-- 采购填写 -->
          <el-form-item label="付款周期" prop="payCycle">
            <el-input v-model="dataForm.payCycle" placeholder="付款周期"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <!-- 采购填写 -->
          <el-form-item label="付款方式" prop="payWay">
            <el-select v-model="dataForm.payWay" placeholder="请选择" clearable @focus="getJobs">
              <el-option
                v-for="item in payTypeList"
                :key="item.key"
                :label="item.name"
                :value="item.key"/>
            </el-select>
          </el-form-item>       
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="业务联系人（A）" prop="contactor">
            <el-input v-model="dataForm.contactor" placeholder="业务联系人（A）"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="销售副总（B）" prop="purchaseVicePresident">
            <el-input v-model="dataForm.purchaseVicePresident" placeholder="销售副总（B）"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="手机（A）" prop="contractorMobile">
            <el-input v-model="dataForm.contractorMobile" placeholder="手机（A）"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机（B）" prop="purchaseVicePresidentMobile">
            <el-input v-model="dataForm.purchaseVicePresidentMobile" placeholder="手机（B）"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="E-mail（A）" prop="orderRequirement">
            <el-input v-model="dataForm.contractorMail" placeholder="E-mail（A）"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="E-mail（B）" prop="purchaseVicePresidentMail">
            <el-input v-model="dataForm.purchaseVicePresidentMail" placeholder="E-mail（B）"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="技术最高决策人（C）" prop="techRepresentative">
            <el-input v-model="dataForm.techRepresentative" placeholder="技术最高决策人（C）"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="质量最高决策人（D）" prop="qualityRepresentative">
            <el-input v-model="dataForm.qualityRepresentative" placeholder="质量最高决策人（D）"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="手机（C）" prop="purchaseVicePresidentMobile">
            <el-input v-model="dataForm.purchaseVicePresidentMobile" placeholder="手机（C）"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机（D）" prop="qualityRepresentativeMobile">
            <el-input v-model="dataForm.qualityRepresentativeMobile" placeholder="手机（D）"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="E-mail（C）" prop="purchaseVicePresidentMail">
            <el-input v-model="dataForm.purchaseVicePresidentMail" placeholder="E-mail（C）"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="E-mail（D）" prop="qualityRepresentativeMail">
            <el-input v-model="dataForm.qualityRepresentativeMail" placeholder="E-mail（D）"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="邮编" prop="postCode">
            <el-input v-model="dataForm.postCode" placeholder="邮编"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司网址" prop="supplierAddress">
            <el-input v-model="dataForm.supplierAddress" placeholder="公司网址"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="供应商与公司关系" prop="supplierRelation">
            <el-radio-group v-model="dataForm.supplierRelation">
              <el-radio :label="item.key" :key="item.key" v-for="item in supplierComRelateList">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="供应商所有权结构" prop="orderRequirement">
            <el-radio-group v-model="dataForm.supplierStru">
              <el-radio :label="item.key" :key="item.key" v-for="item in supplierStruList">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="运输方式" prop="orderRequirement">
            <el-radio-group v-model="dataForm.transportWay">
              <el-radio :label="item.key" :key="item.key" v-for="item in transportWayList">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>          
        </el-col>
      </el-row>
     <!--  <el-row v-if="false">
        <el-col :span="24" >
          <el-form-item label="路径" prop="path">
            <el-input v-model="dataForm.path" readonly placeholder="路径"></el-input>
          </el-form-item>  
        </el-col>
      </el-row>   -->
    </el-form>
    <el-row :gutter="40">
      <el-col :span="24" style="text-align:right;">
        <el-button size="small" @click="viewData.visible = false">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()">
          提交
        </el-button>
        <el-button size="small" type="danger" @click="dataFormSubmit()">
          冻结
        </el-button>
        <el-button size="small" type="success" @click="dataFormSubmit()">
          生成编码
        </el-button>
      </el-col>
    </el-row>
    <!-- 供应商固定资产维护 -->
  </el-dialog>
</template>

<script>
  // import {getOrderDetail, createOrg, editOrg} from '@/controller/sys'
  import moment from 'moment'
  export default {
    data () {
      return {
        viewData: {
          visible: false,
          width:''
        },
        supplierTypeList: [{key: 0, name: "潜在供应商"}, {key: 1, name: "合格供应商"}],
        payTypeList: [{key: 0, name: "承兑"}, {key: 1, name: "电汇"}],
        supplierComRelateList: [{key: 0, name: "公司所属供应商"}, {key: 1, name: "股东供应商"}, {key: 2, name: "一般供应商"}],
        supplierStruList: [{key: 0, name: "国有(集体)控股"}, {key: 1, name: "私有控股"}, {key: 2, name: "中外合资企业"}, {key: 3, name: "外商独资企业"}],
        transportWayList: [{key: 0, name: "公路"}, {key: 1, name: "铁路"}, {key: 2, name: "海运"}],
        dataList: [],
        dataForm: {
          id: 0,
          name: '',
          code: '',
          parentId: '',
          parentName: '',
          parentNodePath: '',
          tenantId: '',
          tenantName: ''
        },
        dataRule: {
          name: [
            { required: true, message: '组织名称不能为空', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '组织代码不能为空', trigger: 'blur' }
          ],
          tenantName: [
            { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
    },
    methods: {
      init (data) {
        console.log(data)
        this.dataForm = data ? data : {}
        // this.dataForm.id = id || 0
        this.viewData.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
          if (this.dataForm && this.dataForm.id) {
            // getOrderDetail(
            //         // {},this.dataForm.id
            // ).then(data => {
            //   console.log(data)
            //   if (data && data.code === '00') {
            //     this.dataList = data.body
            //     // this.dataForm.name = data.body.orgName
            //     // this.dataForm.code = data.body.orgCode
            //     // this.dataForm.parentId = data.body.parentId
            //     // this.dataForm.parentName = data.body.parentName
            //   }
            // })
          }
        })
      },
      dateFormat:function(row,column){
        var date = row[column.property]
        if(date == undefined){return ''}
        return moment(date).format("YYYY-MM-DD前")
      },
      // 表单提交
      dataFormSubmit () {
      }
    }
  }
</script>


<style lang="scss">
  .el-dialog__body{
    .org-dialog-form{
      width: 95%;
    }
  }
  .linetext {
    white-space: pre-line;
  }
</style>